module.exports = __webpack_public_path__ + "static/hanafield-d44f3e52e0d60296381ac6b99030b3f6.jpg";